import { render, staticRenderFns } from "./ThankYouUs.vue?vue&type=template&id=9f713104&scoped=true&"
var script = {}
import style0 from "./ThankYouUs.vue?vue&type=style&index=0&id=9f713104&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f713104",
  null
  
)

export default component.exports